import React, { useEffect, useState } from 'react';
import { Modal, Box, TextField, Button, FormControl, Typography, Select, MenuItem, Grid, InputLabel, Alert, AlertTitle, CircularProgress, Chip, IconButton } from '@mui/material';
import { API } from 'aws-amplify';
import CloseIcon from '@mui/icons-material/Close';
import { addUser, getDropdownData } from '../Queries';


const Register = ({ open, onClose }) => {
    const [registerData, setRegisterData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phoneNumber: '',
        dateOfBirth: '',
        qualification: '',
        purpose: '',
        graduationYear: '',
        programCode: '',
        role: 'Student',
        status: "Active",
        selectedCourses: []
    });
    const [loading, setLoading] = useState(false);
    const [registrationCodes, setRegistrationCodes] = useState([]);
    const [regCourses, setRegCourses] = useState([]);
    const [alert, setAlert] = useState({
        open: false,
        severity: 'success', // 'success' or 'error'
        message: '',
    });
    const handleCloseAlert = () => {
        setAlert({
            ...alert,
            open: false,
        });
        setRegisterData({
            username: '',
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            phoneNumber: '',
            qualification: '',
            graduationYear: '',
            programCode: '',
            role: 'Student',
            status: "Active",
            selectedCourses: []
        });
        onClose();
    };
    const handleSuccess = (message) => {
        setAlert({
            open: true,
            severity: 'success',
            message,
        });
        setLoading(false); // Hide loader
    };

    const handleError = (message) => {
        setAlert({
            open: true,
            severity: 'error',
            message,
        });
        setLoading(false); // Hide loader
    };
    const handleChange = (event) => {
        setRegisterData({
            ...registerData,
            [event.target.name]: event.target.value,
        });
    };
    const handleCourseChange = (event) => {
        setRegisterData({
            ...registerData,
            selectedCourses: event.target.value,
        });
    };
    const handleSubmit = async () => {
        let apiName = 'Node-API';
        let path = ''; //replace this with the path you have configured on your API
        let params = {
            body:
            {
                "command": "sendRegistrationRequest",
                "email": "sureshbanala97@gmail.com",
                "message": `
                <p>Dear Team, <br><br>

                    Greetings from <b>Carrer Excel-lence!!</b> <br><br>

                    Following are the new user registration details <br><br> 

                    <table border="1">
                        <tr>
                            <th>Field</th>
                            <th>Details</th>
                        </tr>
                        <tr>
                            <td>First Name</td>
                            <td>${registerData.firstName}</td>
                        </tr>
                        <tr>
                            <td>Last Name</td>
                            <td>${registerData.lastName}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>${registerData.email}</td>
                        </tr>
                        <tr>
                            <td>Phone Number</td>
                            <td>${registerData.phoneNumber}</td>
                        </tr>
                        <tr>
                            <td>Date of Birth</td>
                            <td>${registerData.dateOfBirth}</td>
                        </tr>
                        <tr>
                            <td>Qualification</td>
                            <td>${registerData.qualification}</td>
                        </tr>
                        <tr>
                            <td>Purpose of Joining</td>
                            <td>${registerData.purpose}</td>
                        </tr>
                        <tr>
                            <td>Year of Graduation</td>
                            <td>${registerData.graduationYear}</td>
                        </tr>
                        <tr>
                            <td>Courses Selected</td>
                            <td>${registerData.selectedCourses}</td>
                        </tr>
                    </table>

                    Thanks & Regards, <br>
                    <b>Carrer Excel-lence</b> <br>
                </p>`,
                "subject": "New Student Registration"
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        API.post(apiName, path, params).then(response => {
            if (response.err == null && response.data != null) {
                handleSuccess('Registration successful!, Please use your registered email & password to login');
            }
        }
        ).catch(error => {
            //console.log(error);
            handleError('Registration failed. Please try again.');
        });
    };
    const handleRegistration = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            let response = await addUser(registerData, false);
            //console.log(response);
            if (response.data && response.data.statusCode === 200) {
                handleSubmit();
            }
        } catch (error) {
            setLoading(false);
            handleError('Registration failed. Please try again.');
        }
    }
    const getDropDowns = async () => {
        try {
            const dropdownData = await getDropdownData();

            const result1 = dropdownData.filter(item => item.type === "program_code");
            const result2 = dropdownData.filter(item => item.type === "registration_course");

            setRegistrationCodes(result1);
            setRegCourses(result2);
        } catch (error) {
            //console.log('An error occurred while fetching dropdown data.', error);
        }
    };

    useEffect(() => {
        getDropDowns()
    }, [])

    return (
        <Modal open={open} onClose={onClose} hideBackdrop={true} style={{ bgcolor: "#cfcfcf !important" }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%', // Set the width to 90% for better responsiveness
                    maxWidth: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    maxHeight: '80vh', // Set a maximum height with a viewport percentage
                    overflowY: 'auto', // Enable vertical scrolling
                    textAlign: 'center',

                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        color: 'text.secondary',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {loading &&
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
                        <CircularProgress />
                    </div>}
                {alert.open && (
                    <Alert severity={alert.severity} onClose={handleCloseAlert}>
                        <AlertTitle>{alert.severity === 'success' ? 'Success' : 'Error'}</AlertTitle>
                        {alert.message}
                    </Alert>
                )}
                {!loading && !alert.open && (
                    <>
                        <Typography variant="h5" gutterBottom>
                            Registration form
                        </Typography>
                        <br />
                        <form onSubmit={handleRegistration}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="First Name"
                                            type="text"
                                            name="firstName"
                                            value={registerData.firstName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Last Name"
                                            type="text"
                                            name="lastName"
                                            value={registerData.lastName}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Email"
                                            type="email"
                                            name="email"
                                            value={registerData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Password"
                                            type="text"
                                            name="password"
                                            value={registerData.password}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Phone Number"
                                            type="tel"
                                            name="phoneNumber"
                                            value={registerData.phoneNumber}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Date of Birth"
                                            type="date"
                                            name="dateOfBirth"
                                            value={registerData.dateOfBirth}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Qualification"
                                            type="text"
                                            name="qualification"
                                            value={registerData.qualification}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Purpose of Joining"
                                            type="text"
                                            name="purpose"
                                            value={registerData.purpose}
                                            onChange={handleChange}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="graduationYearLabel">Graduation Year *</InputLabel>
                                        <Select
                                            labelId="graduationYearLabel"
                                            label="Graduation Year"
                                            name="graduationYear"
                                            value={registerData.graduationYear}
                                            onChange={handleChange}
                                            required
                                            renderValue={(selected) => (
                                                <div style={{ textAlign: 'left' }}>{selected}</div>
                                            )}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Year
                                            </MenuItem>
                                            {Array.from({ length: 10 }, (_, index) => new Date().getFullYear() - index).map((year) => (
                                                <MenuItem key={year} value={year}>
                                                    {year}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="rc-label">Registration Code *</InputLabel>
                                        <Select
                                            labelId="rc-label"
                                            // id="rc"
                                            label="Registration Code"
                                            name="programCode"
                                            value={registerData.programCode}
                                            onChange={handleChange}  // Use the correct handler
                                            required
                                            renderValue={(selected) => (
                                                <div style={{ textAlign: 'left' }}>{selected}</div>
                                            )}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Registration Code
                                            </MenuItem>
                                            {registrationCodes.map((item) => (
                                                <MenuItem key={item.id} value={item.name}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="course-label">Select Courses *</InputLabel>
                                        <Select
                                            labelId="course-label"
                                            id="course"
                                            label="Select Courses"
                                            name="course"
                                            // multiple
                                            value={registerData.selectedCourses}
                                            onChange={handleCourseChange}
                                            renderValue={(selected) => (
                                                <div style={{ textAlign: 'left' }}>{selected}</div>
                                            )}
                                            required
                                        >
                                            <MenuItem value="" disabled>
                                                Select Registration Course
                                            </MenuItem>
                                            {regCourses.map((item) => (
                                                <MenuItem key={item.id} value={item.name}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {/* <br /> */}
                            {/* <Button variant="contained" color="primary" onClick={onClose}>
                                Close
                            </Button> */}

                            <Button type="submit" variant="contained" color="primary" sx={{
                                mt: '20px', width: '100%', fontSize: 'inherit', borderRadius: '20px', textTransform: 'capitalize', bgcolor: '#0a0068',
                                '&:hover': {
                                    bgcolor: '#0c0082',
                                },
                            }}>
                                Register
                            </Button>
                        </form>
                    </>
                )}
            </Box>
        </Modal>

    );
};

export default Register;
